<template>
  <div>
    <el-dialog :title="title" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
               @close="closeDialog">
      <div style="text-align: right; position: absolute; top:20px; right: 100px;">
        <el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
      </div>
      <div style="width: 800px; height: 600px; overflow-y: scroll; border: 1px solid #ccc; margin: 0 auto;">
        <div id="printMe"
             style=" width: 700px; margin: 0 auto; height: 1000px;">
          <div class="stuBox" style="page-break-after:always;">

            <div class="title flexCloumnSingleCenter">
              <div class="FS18 bold" style="line-height: 50px;">学生住校申请表</div>
            </div>
            <div class="table">
              <el-row class="borderR">
                <el-col :span="6" class="cell cell50">班级</el-col>
                <el-col :span="6" class="cell cell50">{{ detailInfo.class }}</el-col>
                <el-col :span="6" class="cell cell50">姓名</el-col>
                <el-col :span="6" class="cell cell50">{{ detailInfo.stuName }}</el-col>
              </el-row>
              <el-row class="borderR">
                <el-col :span="3" class="cell cell50">性别</el-col>
                <el-col :span="3" class="cell cell50">
                  {{ detailInfo.gender == 1 ? '男' : '' }}
                  {{ detailInfo.gender == 2 ? '女' : '' }}
                  {{ detailInfo.gender == 0 ? '未知' : '' }}
                </el-col>
                <el-col :span="3" class="cell cell50">现居地</el-col>
                <el-col :span="15" class="cell cell50">{{ detailInfo.address }}</el-col>
              </el-row>

              <el-row class="flexStretch borderR">
                <el-col :span="6" class="cell cell50 flexCenter" style="line-height: unset">申请住校<br/>简述<br/></el-col>
                <el-col :span="18">
                  <el-row class="cellMore flexCenter" style="padding: 10px;">{{detailInfo.remark}}</el-row>
                </el-col>
              </el-row>

              <el-row class="cell borderR">
                <el-row class="">
                  <el-col :span="1" class="cell50"></el-col>
                  <el-col :span="6" class="cell50 flexStart">系部意见:</el-col>
                </el-row>
                <el-row class="">
                  <el-col :span="18" class="cell50 flexEnd">负责人签名:</el-col>
                </el-row>
              </el-row>
              <el-row class="cell borderR borderB">
                <el-row class="">
                  <el-col :span="1" class="cell50"></el-col>
                  <el-col :span="6" class="cell50 flexStart">学工处意见:</el-col>
                </el-row>
                <el-row class="">
                  <el-col :span="18" class="cell50 flexEnd">负责人签名:</el-col>
                </el-row>
              </el-row>
              <div style="padding-left: 10px;padding-top: 5px;font-weight: 700;">附：乘坐102路、6路、117路直达到学校</div>

            </div>

          </div>

        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {


  props: {
    detailInfo:{
      name: "",
      gender: 0
    },
    baseInfo:{
      type: Object,
      default:{},
    },
    dialogNum:0,
    title:'',
  },
  data() {
    return {
      isShowModal: true,
    }
  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$parent.closePrint()
    }
  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.flexStretch{
  display: flex;justify-content: flex-start;align-items: stretch;
}
.stuBox{
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  .posIndex{
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }
  .table{
    width: 100%;
  }
  .borderR {border-right: 1px solid #333;}
  .borderB {border-bottom: 1px solid #333;}
  .FS18{
    font-size: 18px;
  }
  .bold{
    font-weight: 700;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
  .cell{
    border-left: 1px solid #333;
    border-top: 1px solid #333;

    min-height: 30px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    font-family:"宋体";
  }
  .cell50{
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family:"宋体";
  }
  .cellMore{
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    min-height: 50px;
    text-align: left;
    font-size: 14px;
    font-family:"宋体";
  }
}
.uline {
  text-decoration: underline;
}
</style>
